import { AvailableQuestionTypes } from "./components/QuestionTypePicker";
import { useTheme } from "@mui/material";
import FruitifyIcon from "../../shared-components/FruitifyIcons";
import React from "react";

// TODO: tests?

export const getQuestionTypeIcon = (Icon, color) => {
  const theme = useTheme();
  const resolvedColor = color ?? (theme.vars || theme).palette.primary.main;

  if (typeof Icon === "string") {
    return (
      <FruitifyIcon
        name={Icon}
        style={{
          marginLeft: 4,
          color: resolvedColor,
        }}
      />
    );
  }
  return <Icon style={{ marginLeft: 4 }} />;
};

function getQuestionTypeMeta(question) {
  const QUESTION_TYPE_CONFIG = {
    [AvailableQuestionTypes.LongText.backendName]: {
      label: "Text",
      icon: getQuestionTypeIcon(
        AvailableQuestionTypes.LongText.icon,
        "inherit",
      ),
    },
    [AvailableQuestionTypes.MultipleChoice.backendName]: {
      label: "MCQ",
      icon: getQuestionTypeIcon(
        AvailableQuestionTypes.MultipleChoice.icon,
        "inherit",
      ),
    },
    [AvailableQuestionTypes.TrueFalse.backendName]: {
      label: "True/False",
      icon: getQuestionTypeIcon(
        AvailableQuestionTypes.TrueFalse.icon,
        "inherit",
      ),
    },
  };
  return (
    QUESTION_TYPE_CONFIG[question.questionType] ?? {
      label: "Unknown",
      icon: null,
    }
  );
}

const formatEntityType = (value) => {
  if (!value) return "";

  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export { getQuestionTypeMeta, formatEntityType };
